import { useEffect, useState } from 'react';

const insertCustomeStylesheet = ({ isRTL, isDark }, cb) => {

  const link = document.createElement('link');
  link.href = `${process.env.PUBLIC_URL}/css/varexe.min.css`;
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.className = 'theme-stylesheet';

  link.onload = cb;
  document.getElementsByTagName('head')[0].appendChild(link);
  document.getElementsByTagName('html')[0].setAttribute('dir', isRTL ? 'rtl' : 'ltr');



};

// Fallback timeout (ms): on some mobile browsers/WebViews, dynamically injected
// <link> onload never fires (cache/timing). After this delay we show the app anyway.
const THEME_LOAD_FALLBACK_MS = 3000;

const useToggleStylesheet = (isRTL, isDark, configDispatch) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    Array.from(document.getElementsByClassName('theme-stylesheet')).forEach(
      link => link.remove()
    );
    const link = document.createElement('link');
    link.href = `${process.env.PUBLIC_URL}/css/theme${
      isRTL ? '-rtl' : ''
    }.min.css`;
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.className = 'theme-stylesheet';

    let fallbackTimer;
    const markLoaded = () => {
      if (fallbackTimer) clearTimeout(fallbackTimer);
      fallbackTimer = null;
      setIsLoaded(true);
    };

    link.onload = markLoaded;
    // If stylesheet fails (404, network), still show the app.
    link.onerror = markLoaded;

    document.getElementsByTagName('head')[0].appendChild(link);
    document
      .getElementsByTagName('html')[0]
      .setAttribute('dir', isRTL ? 'rtl' : 'ltr');

    insertCustomeStylesheet({ isRTL, isDark }, configDispatch);

    // Mobile fallback: some devices never fire link.onload for dynamic stylesheets.
    fallbackTimer = setTimeout(markLoaded, THEME_LOAD_FALLBACK_MS);
    return () => {
      if (fallbackTimer) clearTimeout(fallbackTimer);
    };
  }, [isRTL]);



  useEffect(() => {
    document.documentElement.classList[isDark ? 'add' : 'remove']('dark');
    // document.querySelector('html').setAttribute('data-kit-theme', (isDark ? 'dark' : 'default'))
    
    configDispatch({
      type: 'RESET'
    });
  }, [isDark]);

  return { isLoaded };
};

export default useToggleStylesheet;
